import React, { useEffect, useRef, useState } from "react";

const CarGame = () => {
  const canvasRef = useRef(null);
  const [gameOver, setGameOver] = useState(false);
  const carWidth = 50;
  const carHeight = 100;
  const canvasWidth = 400;
  const canvasHeight = 600;
  const roadWidth = canvasWidth;
  let carX = canvasWidth / 2 - carWidth / 2;
  let carY = canvasHeight - carHeight - 20;
  let obstacles = [];
  let score = 0;

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const drawCar = () => {
      ctx.fillStyle = "blue";
      ctx.fillRect(carX, carY, carWidth, carHeight);
    };

    const drawObstacle = (obstacle) => {
      ctx.fillStyle = "red";
      ctx.fillRect(obstacle.x, obstacle.y, obstacle.width, obstacle.height);
    };

    const moveObstacles = () => {
      for (let obstacle of obstacles) {
        obstacle.y += 5;
      }

      obstacles = obstacles.filter((obstacle) => obstacle.y < canvasHeight);
    };

    const createObstacle = () => {
      const width = Math.random() * 50 + 50;
      const x = Math.random() * (roadWidth - width);
      obstacles.push({ x, y: -100, width, height: 20 });
    };

    const checkCollision = () => {
      for (let obstacle of obstacles) {
        if (
          carX < obstacle.x + obstacle.width &&
          carX + carWidth > obstacle.x &&
          carY < obstacle.y + obstacle.height &&
          carY + carHeight > obstacle.y
        ) {
          setGameOver(true);
          return;
        }
      }
    };

    const drawScore = () => {
      ctx.fillStyle = "black";
      ctx.font = "20px Arial";
      ctx.fillText(`Score: ${score}`, 10, 30);
    };

    const gameLoop = () => {
      ctx.clearRect(0, 0, canvasWidth, canvasHeight);

      if (gameOver) {
        ctx.fillStyle = "black";
        ctx.font = "40px Arial";
        ctx.fillText("Game Over!", canvasWidth / 4, canvasHeight / 2);
        return;
      }

      drawCar();
      moveObstacles();

      if (Math.random() < 0.02) {
        createObstacle();
      }

      for (let obstacle of obstacles) {
        drawObstacle(obstacle);
      }

      checkCollision();
      drawScore();
      score++;

      requestAnimationFrame(gameLoop);
    };

    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft" && carX > 0) {
        carX -= 20;
      }
      if (e.key === "ArrowRight" && carX < canvasWidth - carWidth) {
        carX += 20;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    gameLoop();

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [gameOver]);

  return (
    <div>
      <h2>Car Game</h2>
      <canvas
        ref={canvasRef}
        width={canvasWidth}
        height={canvasHeight}
        style={{ border: "1px solid black" }}
      />
      {gameOver && (
        <button onClick={() => window.location.reload()}>Restart</button>
      )}
    </div>
  );
};

export default CarGame;
